import * as Yup from 'yup';
import { Certification } from '@models';

export function useValidationSchema() {
  return Yup.object<Certification>().shape({
    certification: Yup.object<Certification>().required('Povinné pole'),
    validFrom: Yup.string().required('Povinné pole'),
    validTo: Yup.string().required('Povinné pole'),
  });
}
